import { ofType, StateObservable } from 'redux-observable';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { NextCoachingService } from '../../../../coaching-base/coaching.service';
import { Dependencies } from '../../../../store';
import { PayloadAction } from '../../../../store.model';
import { BehaviourLibraryService } from '../../core';
import { ActionType } from '../bl-dialog.action';

import { Reload, ReloadResult, reloadResult } from './reload.action';

export const reloadEpic = (
    action: Observable<PayloadAction<ActionType, Reload>>,
    state: StateObservable<any>,
    deps: Dependencies,
): Observable<PayloadAction<ActionType, ReloadResult>> =>
    action.pipe(
        ofType(ActionType.COACHING__BL__RELOAD),
        switchMap((act: PayloadAction<ActionType, Reload>) => {
            const coachingService =
                deps.injector?.get<NextCoachingService>(NextCoachingService);
            const service = deps.injector.get<BehaviourLibraryService>(
                BehaviourLibraryService,
            );

            return forkJoin([
                of(null).pipe(coachingService.retrieveLookupBox()),
                service.listDocumentFocuses(true),
            ]).pipe(
                map((ret) => {
                    return reloadResult(
                        {
                            ...act.payload,
                            behaviours: ret[0]?.behaviours,
                            subBehaviours: ret[0]?.subBehaviours,
                            focuses: ret[1],
                        },
                        act.storePath,
                    );
                }),
                catchError((err) => {
                    console.log(err);
                    return of(null);
                }),
            );
        }),
    );
